import { type PropsWithChildren } from 'react';
import { Paragraph } from '#components/Typography/Paragraph';
import {
  Tooltip as TooltipComponent,
  TooltipContent,
  TooltipTrigger,
} from '#components/Data/Tooltip';
import { colors } from '#themes/stena-recycling';

export const Tooltip = ({ children }: PropsWithChildren) => {
  if (children) {
    return (
      <TooltipComponent placement="right">
        <TooltipTrigger color={colors.primary.blue} />
        <TooltipContent>
          <Paragraph variant="medium">{children}</Paragraph>
        </TooltipContent>
      </TooltipComponent>
    );
  }

  return null;
};
